export default function getRemoveDuplicatedArray(value: Array<string>): Array<string> {
  const set = new Set(value);
  const newArray: Array<string> = [];
  set.forEach((item) => {
    newArray.push(item);
  });
  return newArray;
}
